import { Temporal } from "temporal-polyfill"

export { Temporal }

export const formatDate = (
  value: string | null | undefined,
  options: { locale?: Intl.LocalesArgument; timeZone?: string } = {}
): string | null => {
  if (value == null) return null
  return Temporal.Instant.from(value)
    .toZonedDateTimeISO(options.timeZone ?? Temporal.Now.timeZoneId())
    .toLocaleString(options.locale, { dateStyle: "medium" })
}
